import type { Resource } from '../../';
export const cart_couponCodes_rejection_notFound: Resource = {"default":"The requested coupon was not found."};
